import UserResult from "../common/UserResult";

export class UserResultRow {
    constructor(private data: UserResult) {

    }

    get name(): string {
        return this.data.firstName + ' ' + this.data.lastName;
    }

    get userName(): string {
        return this.data.username as string;
    }

    get score(): number | undefined {
        return this.data.mainScore;
    }

    get latePenalties(): number | undefined {
        return this.data.latePenalties;
    }

    get reviewPoints(): number | undefined {
        return this.data.reviewPoints;
    }

    getTags(): string[] {
        return this.data.getAllTags();
    }

    hasResults(): boolean {
        return this.data.results && this.data.results.length > 0;
    }

    getPoints(tag: string): number | undefined {
        return this.data.getResultOrEmpty(tag).points;
    }

    hasCodeMatchProblem(): boolean {
        return !!this.data.codeMatchProblem;
    }
}
